var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { lighten } from 'polished';
export const RelativeContainer = styled.div `
  position: relative;
`;
export const FloatingContainer = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
`;
export const Blurrer = styled.div `
  filter: ${(props) => (props.loading ? 'blur(2px)' : 'none')};
`;
export const LoadingContainer = styled.div `
  display: block;
  width: ${(props) => props.size}rem;
  height: ${(props) => props.size}rem;
  margin: ${(props) => props.size / 3}rem auto;
`;
export const spin = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
});
export const Spinner = styled.div `
  animation: ${spin} 1.6s infinite linear;
  border: 0.5rem solid ${(props) => lighten(0.6, props.theme.primaryColour)};
  border-top-color: ${(props) => props.theme.activeColour};
  border-radius: 50%;
  height: 100%;
  width: 100%;
`;
export const Loading = ({ size }) => (React.createElement(LoadingContainer, { size: size || 9 },
    React.createElement(Spinner, null)));
export const FloatingLoading = (_a) => {
    var { children, loading } = _a, loadingProps = __rest(_a, ["children", "loading"]);
    return (React.createElement(RelativeContainer, null,
        React.createElement(Blurrer, { loading: loading }, children),
        loading && (React.createElement(FloatingContainer, null,
            React.createElement(Loading, Object.assign({}, loadingProps))))));
};
//# sourceMappingURL=loading.js.map